import * as contentStatus from '../constants/contentStatus';
import * as requestStatus from '../constants/imagePreloading';
export function isOpen(state) {
    return state.grid.isOpen;
}
export function getThumbStatus(state, screenID) {
    var screen = state.project.config.screenMap[screenID];
    var loadingStatus = state.grid.isThumbLoaded[screenID];
    var uploadError = screen.contentStatus === contentStatus.IMAGE_UPLOAD_ERROR;
    var uploadPending = screen.contentStatus === contentStatus.IMAGE_UPLOAD_PENDING;
    var isDownloading = !uploadError && !uploadPending && !loadingStatus;
    var downloadError = loadingStatus === requestStatus.ERROR;
    return {
        uploadError: uploadError,
        uploadPending: uploadPending,
        isDownloading: isDownloading,
        downloadError: downloadError,
        isLoaded: !uploadPending && !uploadError && !isDownloading && !downloadError,
    };
}
